import React, { useMemo, useState } from 'react';
import Competitor from '../Competitor';
import Gpt, { useKeyOpinionPromptList } from '@op/components/GPT';
import { connect, useIntl } from 'umi';

function MentionsRight({ filter, gameInfo, wholeGameInfo }: any) {
  const { formatMessage } = useIntl();
  const [showGptBtn, setShowGptBtn] = useState(true);
  const keyOpinionsPromptList = useKeyOpinionPromptList({
    gameInfo: wholeGameInfo,
  });
  const params = useMemo(() => {
    return { ...gameInfo, ...filter };
  }, [filter]);

  return (
    <>
      <Gpt.PageCard
        filter={params}
        hasStopBtn={true}
        autoRequest={false}
        alwaysShowTitle
        linkFilterChange={false}
        className={'dbo-aigc-card-wrapper'}
        loadingHeight={36}
        promptList={keyOpinionsPromptList}
        saveName="Performance"
        getGptShowChildren={(value: any) => setShowGptBtn(value)}
        title={formatMessage({ id: 'Feeds AI Summary' })}
      >
        {(toggleVisible: any, { total }: any) => (
          <div className="gpt-summary-entry-tips">
            <Gpt.Button
              disabled={total <= 0}
              onClick={() => toggleVisible()}
            ></Gpt.Button>
          </div>
        )}
      </Gpt.PageCard>
      <Competitor filter={filter} showAigcCard={!showGptBtn} />
    </>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(MentionsRight);
